import React from 'react'

const VerifiedMemberPoints = ({ title = "", items = [], mainContainerClass = "",titleClass = "" }) => {
    return (
        <section className={`w-full bg-gradient-radial py-12 lg:py-24 ${mainContainerClass || ""}`}>
            <div className="container mx-auto px-4 lg:px-15">
                <h2 className={`text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center mb-8 lg:mb-12 ${titleClass || ""}`}>
                    {title || ""}
                </h2>
                <div className="flex flex-row flex-wrap gap-10 justify-center font-urbanist">
                    {
                        items.map((pointDetails, index) => {
                            return (
                                <div
                                    key={index}
                                    className="w-full lg:w-1/4 md:w-1/3 flex flex-col rounded-xl items-center bg-white hover:scale-105 transition-transform duration-500 shadow-[0px_0px_7px_4px_rgba(171,198,248,0.5)] p-8 text-center">
                                    <div className="p-2">
                                        <img className="w-20 h-20" src={pointDetails.path} alt={pointDetails.name} />
                                    </div>
                                    <h3 className="mt-4 text-black text-2xl sm:text-3xl lg:text-3xl font-bold">{pointDetails.name}</h3>
                                    <p className="mt-2 text-gray-800 text-md">{pointDetails.description}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default VerifiedMemberPoints